import React, {useEffect, useRef, useState} from 'react';
import {
    getClientWebChatConf,
    updateClientWebChatColorsConf,
    updateClientWebChatConf
} from "../../../../../../../services/company/api";
import WebChatStyles from "./components/WebChatStyles";
import config from "../../../../../../../config";
import Tabs from "../../../../../../../components-new/ui/Tabs";
import useAvailableHeight from "../../../../../../../utils/hooks/useAvailableHeight";
import './WebChatDesign.css';


const Design = ({client, tariff}) => {
    const {features} = tariff;
    let mainPage;
    if (features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS)) {
        mainPage = 'colors'
    } else if (features.includes(config.features.CUSTOMIZE_WEBCHAT)) {
        mainPage = 'main'
    }
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [colors, setColors] = useState({
        headerBackground: '',
        bodyBackground: '',
        botMessageBackground: '',
        userMessageBackground: '',
        footerBackground: '',
        botTextColor: '',
        userTextColor: '',
        quickReplyTextColor: '',
        isCompleted: false,
    });
    const [texts, setTexts] = useState({
        isCompleted: false
    });
    const [menuItems, setMenuItems] = useState()
    const [profileInfoInputs, setProfileInfoInputs] = useState()
    const [customInputs, setCustomInputs] = useState([]);
    const [defaultPosition, setDefaultPosition] = useState('BOTTOM_RIGHT');
    const [dragEnabled, setDragEnabled] = useState(true);
    const [poweredByConfig, setPoweredByConfig] = useState(true);
    const [operatorPhotoInChat, setOperatorPhotoInChat] = useState(true);
    const [botPhotoInChat, setBotPhotoInChat] = useState(true);
    const [voiceMessagesEnabled, setVoiceMessagesEnabled] = useState(true);
    const [endButton, setEndButton] = useState(true);
    const [profileInfoInputsEnabled, setProfileInfoInputsEnabled] = useState(false);
    const [profileInfoInputsType, setProfileInfoInputsType] = useState('ON_START');
    const [typingIndicatorEnabled, setTypingIndicatorEnabled] = useState(true);
    const [seenIndicatorEnabled, setSeenIndicatorEnabled] = useState(true);
    const [userReactionsEnabled, setUserReactionsEnabled] = useState(false);

    const [activeTab, setActiveTab] = useState(mainPage);
    const containerRef = useRef(null);

    useEffect(() => {
        getClientWebChatConf(client.id).then((data) => {
            setLoading(false);
            setId(data.id);
            setColors({...data.colors, isCompleted: true});
            setTexts({...data.texts, isCompleted: true});
            setMenuItems(data.menuItems)
            setProfileInfoInputs(data.profileInfoInputs)
            setCustomInputs(data.customInputs || []);
            setDefaultPosition(data.defaultPosition || 'BOTTOM_RIGHT');
            setDragEnabled(data.dragEnabled !== false);
            setPoweredByConfig(data.poweredByEnabled)
            setTypingIndicatorEnabled(data.typingIndicatorEnabled)
            setSeenIndicatorEnabled(data.seenIndicatorEnabled)
            setOperatorPhotoInChat(data.operatorPhotoInChat)
            setBotPhotoInChat(data.botPhotoInChat)
            setVoiceMessagesEnabled(data.voiceMessagesEnabled)
            setEndButton(data.endButtonEnabled)
            setProfileInfoInputsEnabled(data.profileInfoInputsEnabled)
            setProfileInfoInputsType(data.profileInfoInputsType)

            if (features.includes(config.features.MESSAGE_REACTIONS)) {
                setUserReactionsEnabled(data.userReactionsEnabled)
            }
        });
    }, [client.id]);

    const saveWebChatConfig = (configId, data) =>
        updateClientWebChatConf(configId, {customInputs, defaultPosition, dragEnabled, ...data});

    const savePositioning = (update) =>
        saveWebChatConfig(id, {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            endButtonEnabled: endButton,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            userReactionsEnabled,
            ...update
        }).then(() => {
            if (update.defaultPosition !== undefined) setDefaultPosition(update.defaultPosition);
            if (update.dragEnabled !== undefined) setDragEnabled(update.dragEnabled);
        });

    const saveCustomInputs = (updated) =>
        saveWebChatConfig(id, {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            endButtonEnabled: endButton,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            userReactionsEnabled,
            customInputs: updated
        }).then(() => setCustomInputs(updated));

    const saveColors = (updateData) => {
        const updatedColors = {...colors, ...updateData};
        return updateClientWebChatColorsConf(id, updatedColors).then(() => {
            setColors(updatedColors);
        });
    }

    const saveMenuItemConfig = (field, data) => {
        setMenuItems(prev => {
            const updated = {...prev, [field]: data};

            const newData = {
                texts,
                poweredByEnabled: poweredByConfig,
                typingIndicatorEnabled,
                seenIndicatorEnabled,
                operatorPhotoInChat,
                botPhotoInChat,
                voiceMessagesEnabled,
                endButtonEnabled: endButton,
                profileInfoInputsEnabled,
                profileInfoInputsType,
                menuItems: updated,
                profileInfoInputs,
                userReactionsEnabled
            };

            saveWebChatConfig(id, newData).then(() => {
            });
            return updated;
        });
    }

    const savePoweredByConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: data,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setPoweredByConfig(data);
        });
    }

    const saveTypingIndicatorConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled: data,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setTypingIndicatorEnabled(data);
        });
    }

    const saveSeenIndicatorConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled: data,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setSeenIndicatorEnabled(data);
        });
    }

    const saveUserReactionsConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled: data
        };
        saveWebChatConfig(id, newData).then(() => {
            setUserReactionsEnabled(data);
        });
    }

    const saveOperatorPhotoInChat = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: data,
            botPhotoInChat,
            voiceMessagesEnabled,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setOperatorPhotoInChat(data);
        });
    }

    const saveBotPhotoInChat = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat,
            botPhotoInChat: data,
            voiceMessagesEnabled,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setBotPhotoInChat(data);
        });
    }

    const saveVoiceMessagesConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled: data,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setVoiceMessagesEnabled(data);
        });
    }

    const saveEndButton = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: operatorPhotoInChat,
            botPhotoInChat: botPhotoInChat,
            voiceMessagesEnabled: voiceMessagesEnabled,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: data,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setEndButton(data);
        });
    }

    const saveProfileInfoInputsConfig = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat: operatorPhotoInChat,
            botPhotoInChat: botPhotoInChat,
            voiceMessagesEnabled: voiceMessagesEnabled,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled: data,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setProfileInfoInputsEnabled(data);
        });
    }

    const saveProfileInfoInputsType = (data) => {
        const newData = {
            texts,
            poweredByEnabled: poweredByConfig,
            operatorPhotoInChat,
            botPhotoInChat,
            voiceMessagesEnabled,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType: data,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };
        saveWebChatConfig(id, newData).then(() => {
            setProfileInfoInputsType(data);
        });
    }

    const saveProfileInfoInputConfig = (field, data) => {
        setProfileInfoInputs(prev => {
            const updated = {...prev, [field]: data};

            const newData = {
                texts,
                poweredByEnabled: poweredByConfig,
                typingIndicatorEnabled,
                seenIndicatorEnabled,
                operatorPhotoInChat,
                botPhotoInChat,
                voiceMessagesEnabled,
                profileInfoInputsEnabled,
                profileInfoInputsType,
                menuItems,
                profileInfoInputs: updated,
                endButtonEnabled: endButton,
                userReactionsEnabled
            };

            saveWebChatConfig(id, newData).then(() => {
            });
            return updated;
        });
    };

    const saveTexts = (updateData) => {
        let hasDifference = false;
        Object.entries(updateData).forEach(([key, value]) => {
            if (texts[key] !== value) hasDifference = true;
        })
        if (!hasDifference) return

        const updatedTexts = {...texts, ...updateData};
        const data = {
            texts: updatedTexts,
            poweredByEnabled: poweredByConfig,
            typingIndicatorEnabled,
            seenIndicatorEnabled,
            operatorPhotoInChat: operatorPhotoInChat,
            botPhotoInChat: botPhotoInChat,
            voiceMessagesEnabled: voiceMessagesEnabled,
            profileInfoInputsEnabled,
            profileInfoInputsType,
            menuItems,
            profileInfoInputs,
            endButtonEnabled: endButton,
            userReactionsEnabled
        };

        saveWebChatConfig(id, data).then(() => {
            setTexts(updatedTexts);
        });
    }

    return (
        <div
            className="web-chat-design"
            ref={containerRef}
            style={{height:'100%'}}
        >
            <Tabs
                selectedTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                    ...(features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS) ? ['colors'] : []),
                    ...(features.includes(config.features.CUSTOMIZE_WEBCHAT) ? ['main', 'menu', 'infoInputs', 'notifications'] : [])
                ]}
            />

            <div className="web-chat-design__body">
                {colors.isCompleted &&
                    <WebChatStyles activeTab={activeTab}
                               features={features}
                               texts={texts}
                               menuItems={menuItems}
                               profileInfoInputs={profileInfoInputs}
                               customInputs={customInputs}
                               defaultPosition={defaultPosition}
                               dragEnabled={dragEnabled}
                               savePositioning={savePositioning}
                               saveCustomInputs={saveCustomInputs}
                               setMenuItems={setMenuItems}
                               colors={colors}
                               poweredByConfig={poweredByConfig}
                               typingIndicatorEnabled={typingIndicatorEnabled}
                               seenIndicatorEnabled={seenIndicatorEnabled}
                               userReactionsEnabled={userReactionsEnabled}
                               operatorPhotoInChat={operatorPhotoInChat}
                               botPhotoInChat={botPhotoInChat}
                               saveBotPhotoInChat={saveBotPhotoInChat}
                               voiceMessagesEnabled={voiceMessagesEnabled}
                               saveVoiceMessagesConfig={saveVoiceMessagesConfig}
                               endButton={endButton}
                               profileInfoInputsEnabled={profileInfoInputsEnabled}
                               profileInfoInputsType={profileInfoInputsType}
                               savePoweredByConfig={savePoweredByConfig}
                               saveTypingIndicatorConfig={saveTypingIndicatorConfig}
                               saveSeenIndicatorConfig={saveSeenIndicatorConfig}
                               saveOperatorPhotoInChat={saveOperatorPhotoInChat}
                               saveEndButton={saveEndButton}
                               saveProfileInfoInputsConfig={saveProfileInfoInputsConfig}
                               saveProfileInfoInputsType={saveProfileInfoInputsType}
                               saveProfileInfoInputConfig={saveProfileInfoInputConfig}
                               saveTexts={saveTexts}
                               saveColors={saveColors}
                               saveMenuItemConfig={saveMenuItemConfig}
                               saveUserReactionsConfig={saveUserReactionsConfig}
                    />
                }
            </div>
        </div>
    );
};

export default Design;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/webChatDesignAndConfig/Design.jsx